import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function userReducer(state = initialState.user, action) {
  switch (action.type) {
    case types.VERIFY_USER:
      return { ...state, ...action.payload };
    case types.CLEAR_USER:
      return initialState.user;
    case types.LOGOUT_USER:
      return { ...state, signedIn: false };
    case types.ADD_USER_ID:
      return { ...state, id: action.id };
    default:
      return state;
  }
}
